import { Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  value?: string;
  vertical?: boolean;
  emptyMessage?: string;
}

const DataCell = ({ label, value, vertical = false, emptyMessage = 'N/A' }: Props) => {
  return (
    <Stack
      direction={vertical ? 'column' : 'row'}
      justifyContent={'space-between'}
    >
      <Typography variant="body1" color="textSecondary">
        {label}
      </Typography>
      <Typography textAlign={vertical ? 'left' : 'right'} variant="body2">{value ?? emptyMessage}</Typography>
    </Stack>
  );
};

export default DataCell;
